module.exports = __webpack_public_path__ + "img/SP3.be9f6bbd.png";